<template>
  <Teleport to="body">
    <div v-if="visible" class="modal-overlay" @click.self="handleClose">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ s__('ProjectSettings|Boards') }}</h3>
          <button type="button" class="modal-close" @click="handleClose" aria-label="Close">
            <CloseIcon />
          </button>
        </div>

        <div class="modal-body">
          <div class="info-section">
            <p>
              {{
                s__(
                  'ProjectSettings|Boards allow you to visualize and organize tasks using a Kanban-style board interface. You can create columns, move tasks between columns, and customize your workflow.'
                )
              }}
            </p>

            <h4>{{ s__('ProjectSettings|How It Works') }}</h4>
            <p>
              {{
                s__(
                  'ProjectSettings|When enabled, project members can create boards with custom columns representing different stages of work. Tasks can be moved between columns to reflect their current status, providing a visual representation of workflow progress.'
                )
              }}
            </p>

            <h4>{{ s__('ProjectSettings|Project Boards') }}</h4>
            <p>
              {{
                s__(
                  'ProjectSettings|Project boards are shared with all members of the project. All team members can view and interact with the board, making it easy to see the status of work across the entire project.'
                )
              }}
            </p>

            <h4>{{ s__('ProjectSettings|Benefits') }}</h4>
            <ul style="margin: 0 0 16px 0; padding-left: 20px; color: #666">
              <li style="margin-bottom: 8px">
                {{ s__('ProjectSettings|Visual representation of task status and workflow') }}
              </li>
              <li style="margin-bottom: 8px">
                {{ s__('ProjectSettings|Easy task organization and status tracking') }}
              </li>
              <li style="margin-bottom: 8px">
                {{ s__('ProjectSettings|Improved team collaboration and visibility') }}
              </li>
              <li style="margin-bottom: 8px">
                {{ s__('ProjectSettings|Customizable workflow columns to match your process') }}
              </li>
            </ul>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-primary" @click="handleClose">
            {{ s__('ProjectSettings|Close') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import { Teleport } from 'vue'
import { s__ } from '@/locale'
import CloseIcon from '../common/icons/CloseIcon.vue'
import { useBodyScrollLock } from '@/composables/useBodyScrollLock'

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['close'])

// Lock body scroll when modal is open
useBodyScrollLock(computed(() => props.visible))

function handleClose() {
  emit('close')
}
</script>

<style scoped>
.info-section {
  line-height: 1.6;
}

.info-section h4 {
  margin: 20px 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.info-section h4:first-child {
  margin-top: 0;
}

.info-section p {
  margin: 0 0 16px 0;
  color: #666;
}

.info-section ul {
  line-height: 1.6;
}
</style>
